import { defaultBreakpoints } from './defaultBreakpoints';
export const getBreakpoints = (customBreakpoints) => customBreakpoints || defaultBreakpoints;
//# sourceMappingURL=getBreakpoints.js.map